<template>
	<t-horizontal-panel :showRightPanel="showRightPanel">
		<order-search-filters
			slot="left"
			@hide="hideDetails"
		/>
		<order-list
			style="flex:1;"
			@showDetails="showDetails"
			@showOrderJson="showOrderJson"
		/>
		<order-details
			v-show="detailsVisible"
			slot="right"
			:orderDetails="orderDetails"
			style="width: 600px;"
			@hide="hideDetails"
		/>
		<EditOrderJson
			v-show="orderJsonVisible"
			slot="right"
			:orderId="orderJsonId"
			style="width: 600px;"
			@hide="hideOrderJson"
		/>
	</t-horizontal-panel>
</template>

<script>
import { mapDynamicState } from '@/core/mapDynamic';
import { tryRegisterStoreDynamically } from './store/orderSearch.store.js';
import OrderSearchFilters from './OrderSearchFilters.vue';
import OrderDetails from './OrderDetails.vue';
import EditOrderJson from '@/modules/editOrderJson/EditOrderJson';
import OrderList from './OrderList.vue';
export default {
	name: 'OrderSearch',
	components: {
		OrderSearchFilters,
		OrderDetails,
		EditOrderJson,
		OrderList,
	},
	data() {
		return { detailsVisible: false, orderJsonVisible: false, };
	},
	computed: {
		...mapDynamicState('computedStoreNamespace', ['orderDetails', 'orderJsonId']),
		searchId() {
			return this.$route.params.searchId || -1;
		},
		computedStoreNamespace() {
			return `orderSearch/${this.searchId}`;
		},
		showRightPanel() {
			return this.detailsVisible || this.orderJsonVisible;
		},
	},
	mounted() {
		document.addEventListener('keyup', this.onKey, { passive: true, capture: true });
	},
	beforeDestroy() {
		document.removeEventListener('keyup', this.onKey, { capture: true });
	},
	methods: {
		showDetails() {
			if (this.orderJsonVisible) this.orderJsonVisible = false;
			this.detailsVisible = true;
		},
		hideDetails() {
			this.detailsVisible = false;
		},
		showOrderJson() {
			if (this.detailsVisible) this.detailsVisible = false;
			this.orderJsonVisible = true;
		},
		hideOrderJson() {
			this.orderJsonVisible = false;
		},
		onKey(e) {
			switch (e.key) {
			case 'Escape': this.hideDetails(); break;
			default: break; // because eslint
			}
		},
	},
	beforeRouteEnter(to, from, next) {
		let id = to.params.searchId || -1;
		tryRegisterStoreDynamically(id);
		next();
	},
	beforeRouteUpdate(to, from, next) {
		let id = to.params.searchId || -1;
		tryRegisterStoreDynamically(id);
		next();
	}
};
</script>

